import ReactDOM from "react-dom";
import { unregister } from "./registerServiceWorker";

import './css/main.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();
